import {
  getAdSlots,
  getDfpProperty, getEdition,
  getHeaderBidderPublisherID,
  getLanguage,
  getPageType,
  getSiteName,
} from '../../store/config/config.selectors';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import {
  GET_PALETTE_DATA,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from '../../client/clientAPI/events';
import { getCountryCode } from '../templates.utils';
import { HomePageNewYorkComponent } from './HomePageNewYorkComponent';
import { configReducer } from '../../store/config/config.reducer';
import { footerReducer } from '../../store/navigation/default/footer/footer.reducer';
import { headerReducer } from '../../store/navigation/default/header/header.reducer';
import { menuReducer } from '../../store/navigation/default/menu/menu.reducer';
import { homePageReducer } from '../../store/template/homePage/homePage.reducer';
import { announcementReducer } from '../../store/announcement/announcement.reducer';
import { getMetadataAdsCategory } from '../../store/template/homePage/homePageNewYork/homePageNewYork.selectors';

export const rootReducer = {
  config: configReducer,
  footer: footerReducer,
  header: headerReducer,
  menu: menuReducer,
  template: homePageReducer,
  siteAnnouncement: announcementReducer,
};

const getCoreParams = (state: AppState) => ({
  siteName: getSiteName(state),
  property: getEdition(state),
  language: getLanguage(state),
  category: getMetadataAdsCategory(state),
  pageType: getPageType(state),
  adSlots: getAdSlots(state),
  headerBidderPublisherID: getHeaderBidderPublisherID(state),
  countryCode: getCountryCode(),
  dfpProperty: getDfpProperty(state),
});

export const HomePageNewYork = new TemplateRegistration()
  .setComponent(HomePageNewYorkComponent)
  .setRootReducer(rootReducer)
  .setCoreParams(getCoreParams)
  .addClientAPIEvent(INJECT_VIDEO_LOGO)
  .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
  .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
  .addClientAPIEvent(GET_PALETTE_DATA)
  .build();
